import React, { useContext } from 'react';
import { CurrencyDisplayProps, CurrencyDisplay } from '@/components/localization';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { Trans } from '@lingui/react/macro';
import { useIsSeller } from '@/utils/hooks';
import { ProjectCurrencyDisplay } from '@/seller/components/currency';
import { getMaximumFractionDigits, getMinimumProjectFractionDigits } from '@/components/localization/CurrencyDisplay';
import { OptionConfiguratorContext } from '@/components/OptionConfigurator/OptionConfiguratorContext';

export const BuyerCurrencyDisplay: React.FC<Omit<CurrencyDisplayProps, 'currency'>> = ({ ...rest }) => {
    const isSeller = useIsSeller();
    // Prefer the configurator context when present (works for both authenticated buyer flow and
    // the public showroom). Fall back to Redux for legacy buyer pages outside the configurator.
    const configuratorCtx = useContext(OptionConfiguratorContext);
    const reduxProjectData = useSelector((state: IState) => state.buyer.projectData);
    const projectData = configuratorCtx?.projectData ?? reduxProjectData;

    if (!projectData || !projectData.currencyCode) {
        if (isSeller) {
            return <ProjectCurrencyDisplay {...rest} />;
        }
        return <Trans>Invalid currency</Trans>;
    }

    return (
        <CurrencyDisplay
            minimumFractionDigits={getMinimumProjectFractionDigits(projectData.decimalOption)}
            maximumFractionDigits={getMaximumFractionDigits(projectData.decimalOption)}
            currency={projectData.currencyCode}
            {...rest}
        />
    );
};
